import { render, staticRenderFns } from "./AuthoritySet.vue?vue&type=template&id=6a9d204b&scoped=true&"
import script from "./AuthoritySet.vue?vue&type=script&lang=js&"
export * from "./AuthoritySet.vue?vue&type=script&lang=js&"
import style0 from "./AuthoritySet.vue?vue&type=style&index=0&id=6a9d204b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9d204b",
  null
  
)

export default component.exports